<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="loaderwrapper" *ngIf="loader">
            <span class="loader"></span>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card table-card">
                    <!-- Title and filters share one row at the top of the card
                         rather than stacking above it. -->
                    <div class="table-toolbar">
                        <h1 class="table-toolbar__title">Heat Map</h1>
                        <div class="sb-filter-holder sb-filter-holder--inline">
                            <div class="input-wrapper">
                                <ng-select [items]="allPlantList" bindLabel="stationName" placeholder="Plants"
                                    bindValue="stationCode" [multiple]="true" [closeOnSelect]="false"
                                    class="sb-filter-field sb-filter-field--md limit-ng-value"
                                    (change)="selectPlants($event)">
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div class="ng-value" *ngIf="i < 1">
                                                <span class="ng-value-label">{{ item.stationName }}</span>
                                                <span class="ng-value-icon right" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                        </ng-container>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">...</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="input-wrapper">
                                <ng-select (change)="selectContractType($event)" placeholder="Contract Type"
                                    [items]="contractTypeList" [multiple]="true" bindLabel="name" bindValue="id"
                                    class="sb-filter-field sb-filter-field--md">
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div class="ng-value" *ngIf="i < 1">
                                                <span class="ng-value-label">{{ item.name }}</span>
                                                <span class="ng-value-icon right" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                        </ng-container>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">...</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="input-wrapper">
                                <ng-select placeholder="Region" (change)="selectRegion($event)" [items]="regionList"
                                    [multiple]="true" bindLabel="name" bindValue="id"
                                    class="sb-filter-field sb-filter-field--md">
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div class="ng-value" *ngIf="i < 1">
                                                <span class="ng-value-label">{{ item.name }}</span>
                                                <span class="ng-value-icon right" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                        </ng-container>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">...</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="input-wrapper">
                                <ng-select (change)="selectCity($event)" placeholder="City" [items]="cititiesList"
                                    [multiple]="true" bindLabel="name" bindValue="id"
                                    class="sb-filter-field sb-filter-field--md">
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <ng-container *ngFor="let item of items; let i = index">
                                            <div class="ng-value" *ngIf="i < 1">
                                                <span class="ng-value-label">{{ item.name }}</span>
                                                <span class="ng-value-icon right" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>
                                        </ng-container>
                                        <div class="ng-value" *ngIf="items.length > 1">
                                            <span class="ng-value-label">...</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="input-wrapper daterange-wrapper">
                                <input type="text" class="sb-filter-field sb-filter-field--md" bsDatepicker
                                    [(ngModel)]="selectedRange" [bsConfig]="datePickerConfig" #dp="bsDatepicker"
                                    (ngModelChange)="onRangeChange($event)" placeholder="Select Month" />

                                <span class="sb-filter-date-icon" (click)="dp.toggle()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                        fill="none">
                                        <path
                                            d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                            fill="currentColor" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="legend-bar">
                        <span class="legend-bar__label">Specific Yield (kWh/kWp)</span>
                        <div class="legend-bar__chips">
                            <div *ngFor="let range of heatLegend" class="legend-item">
                                <span class="color-circle" [style.background]="range.color"></span>
                                <span class="legend-text">{{ range.label }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- .table-wrap is position:relative, so the overlay is
                         bounded by the table on every filter and page change. -->
                    <div class="table-wrap" [class.is-loading]="tableLoader">
                        <div class="loaderwrapper" *ngIf="tableLoader">
                            <span class="loader"></span>
                        </div>
                        <div class="table-main heat-table-scroll">
                            <table class="table-data heat-table">
                                <thead>
                                    <tr>
                                        <th class="text-start plant-name-col">Plant Name</th>
                                        <th *ngFor="let col of heatBoxColumns" class="heat-col"> <span
                                                [matTooltip]="col.date | date:'dd/MMM/yyyy'"
                                                matTooltipClass="custom-tooltip">
                                                {{ col.index | number:'2.0' }} </span> </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <!-- NO VIEW PERMISSION -->
                                    <ng-container *ngIf="!tableLoader && permissionsReady && !permissions.canView">
                                        <tr>
                                            <td colspan="100%">
                                                <div class="no-access text-center p-4">
                                                    You don’t have permission to view this data.
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>

                                    <!-- NO RECORDS -->
                                    <ng-container
                                        *ngIf="!tableLoader && permissionsReady && permissions.canView && (!stationList || stationList.length === 0)">
                                        <tr>
                                            <td colspan="100%">
                                                <p class="not-found-message p-4 text-center">
                                                    No records found.
                                                </p>
                                            </td>
                                        </tr>
                                    </ng-container>

                                    <!-- DATA ROWS -->
                                    <ng-container
                                        *ngIf="!tableLoader && permissionsReady && permissions.canView && stationList?.length > 0">

                                        <tr *ngFor="let plant of stationList">
                                            <td class="plant-name-col">
                                                <div class="d-flex align-items-center gap-2">
                                                    <span *ngIf="plant.status === 'Online'" class="status-circle-online"
                                                        title="Online"></span>
                                                    <span *ngIf="plant.status === 'Offline'"
                                                        class="status-circle-offline" title="Offline"></span>
                                                    <span *ngIf="plant.status === 'Faulty'" class="status-circle-faulty"
                                                        title="Faulty"></span>
                                                    <span class="plant-name-text" [title]="plant.plantName">{{ plant.plantName }}</span>
                                                </div>
                                            </td>

                                            <td *ngFor="let col of plant.yeild_data; let i = index" class="heat-col">
                                                <div [ngClass]="getHeatClass(col.yield)" class="text-center heat-data"
                                                    [matTooltip]="heatBoxColumns[i]?.date | date:'dd/MMM/yyyy'"
                                                    matTooltipClass="custom-tooltip">
                                                    {{ col.yield }}
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-container>

                                </tbody>

                            </table>
                            <div class="table-meta">
                                <div class="entries">
                                    <!-- <div class="dataTables_length p-0">
                            <label class="show-entries-list">
                                Show
                                <select [formControl]="pageSizeControl" (change)="changePageSize()"
                                    class="form-control form-control-sm">
                                    <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                        {{limit.label}}</option>
                                </select>
                                entries
                            </label>
                        </div> -->
                                    <span>Total Records: {{this.total_items }}</span>
                                </div>
                                <nav class="table-pagination">
                                    <ul>
                                        <li>
                                            <div class="go-to-page d-flex align-items-center">
                                                <label>Go to Page:</label>
                                                <input type="number" class="form-control form-control-sm"
                                                    [(ngModel)]="pageToGo" min="1" [max]="total_pages"
                                                    (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                                <div class="input-group-append">
                                                    <button class="btn btn-primary" type="button"
                                                        (click)="goToPage(pageToGo); pageToGo = null"
                                                        [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                                </div>
                                            </div>
                                        </li>
                                        <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                                [class.disabled]="current_page === 1">1</a>
                                        </li>
                                        <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                                    class="fa fa-chevron-left"></i></a>
                                        </li>
                                        <li><a class="active">{{ current_page }}</a></li>
                                        <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                                [class.disabled]="current_page === total_pages"><i
                                                    class="fa fa-chevron-right"></i></a></li>
                                        <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                                [class.disabled]="current_page === total_pages">{{this.total_pages}}</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <!-- <div class="table-main">
                <table class="table-data heat-table">
                    <thead>
                        <tr>
                            <th class="text-start" width="25%">Plant Name</th>
                            <th *ngFor="let col of heatBoxColumns">
                                <span [matTooltip]="col.date" matTooltipClass="custom-tooltip">
                                    {{ col.index }}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!tableLoader; else LoadingRow">
                            <ng-container *ngIf="stationList && stationList.length>0 else noRow">
                                <tr *ngFor="let plant of stationList">
                                    <td>
                                        <div class="d-flex align-items-center gap-2">
                                            <span *ngIf="plant.status === 'Online'"
                                                class="status-circle-online flex-shrink-0" title="Online"></span>
                                            <span *ngIf="plant.status === 'Offline'"
                                                class="status-circle-offline flex-shrink-0" title="Offline"></span>
                                            <span *ngIf="plant.status === 'Faulty'"
                                                class="status-circle-faulty flex-shrink-0" title="Faulty"></span>
                                            <span>
                                                {{ plant.plantName }}
                                            </span>
                                        </div>
                                    </td>
                                    <td *ngFor="let col of plant.yeild_data">
                                        <div class="heat-box" [style.background]="getHeatColor(col['yield'])"
                                            [matTooltip]="col.yield" matTooltipClass="custom-tooltip"></div>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table> -->
                        <!-- <ngx-datatable class="material" [rows]="detail" [columnMode]="'force'" [headerHeight]="50"
                    [footerHeight]="0" [rowHeight]="'auto'" [scrollbarH]="true">
                    <ngx-datatable-column name="Plant Name" [sortable]="false" [width]="200">
                        <ng-template ngx-datatable-header-template>
                            <div class="custom-sort-header d-flex">
                                <span class="cursor-pointer" (click)="sortPlants('plantName')">
                                    Plant Name
                                </span>
                                <span class="sort-btn"
                                    [ngClass]="{ 'datatable-icon-sort-unset': sortOrderPlantName === null, 'datatable-icon-up': sortOrderPlantName === 'asc', 'datatable-icon-down': sortOrderPlantName === 'desc' }"></span>
                            </div>

                        </ng-template>
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center gap-2">
                                <span *ngIf="row.status === 'Online'" class="status-circle-online flex-shrink-0"
                                    title="Online"></span>
                                <span *ngIf="row.status === 'Offline'" class="status-circle-offline flex-shrink-0"
                                    title="Offline"></span>
                                <span *ngIf="row.status === 'Faulty'" class="status-circle-faulty flex-shrink-0"
                                    title="Faulty"></span>
                                <span class="cursor-pointer">
                                    {{ row.plantName }}
                                </span>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column *ngFor="let col of heatBoxColumns" [name]="col" [sortable]="false"
                        [prop]="col" [width]="24">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="heat-box" [style.backgroundColor]="getHeatColor(row[col])"></div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable> -->
                        <!-- <div class="table-meta">
                    <div class="entries">
                        <span>Total Records: {{this.total_items }}</span>
                    </div>
                    <nav class="table-pagination">
                        <ul>
                            <li>
                                <div class="go-to-page d-flex align-items-center">
                                    <label>Go to Page:</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                        min="1" [max]="total_pages"
                                        (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                    <div class="input-group-append">
                                        <button class="btn btn-primary" type="button"
                                            (click)="goToPage(pageToGo); pageToGo = null"
                                            [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                    </div>
                                </div>
                            </li>
                            <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                    [class.disabled]="current_page === 1">1</a>
                            </li>
                            <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                        class="fa fa-chevron-left"></i></a>
                            </li>
                            <li><a class="active">{{ current_page }}</a></li>
                            <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                    [class.disabled]="current_page === total_pages"><i
                                        class="fa fa-chevron-right"></i></a></li>
                            <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                    [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                        </ul>
                    </nav>
                </div>
            </div> -->
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="100%">
            <div class="fw-semibold text-center">
                No data found
            </div>
        </td>
    </tr>
</ng-template>